import {createContext} from 'react';

type MenuItemContextType = {
  openItemIds: Record<string, boolean>;
  toggle: (id: string) => void;
  open: (id: string) => void;
  close: (id: string) => void;
  isOpen: (id: string) => boolean;
};

export const MenuItemsStateContext = createContext<MenuItemContextType | undefined>(undefined);
